import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const FileSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 16 20",
  color = "#fff",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M4.10149 12.5618C3.76869 12.5618 3.52939 12.3225 3.52939 12.0181C3.52939 11.7092 3.76869 11.4699 4.10149 11.4699H11.535C11.8558 11.4699 12.1034 11.7092 12.1034 12.0181C12.1034 12.3225 11.8558 12.5618 11.535 12.5618H4.10149ZM4.10149 16.0673C3.76869 16.0673 3.52939 15.828 3.52939 15.5191C3.52939 15.2147 3.76869 14.9709 4.10149 14.9709H11.535C11.8558 14.9709 12.1034 15.2147 12.1034 15.5191C12.1034 15.828 11.8558 16.0673 11.535 16.0673H4.10149ZM2.8122 19.9998H12.7819C14.6548 19.9998 15.6023 19.0404 15.6023 17.1547V8.50093H8.87183C7.7282 8.50093 7.17926 7.94828 7.17926 6.80465V0H2.8122C0.950423 0 0 0.959501 0 2.84515V17.1547C0 19.0486 0.943013 19.9998 2.8122 19.9998ZM8.90513 7.31849H15.48C15.4315 6.9618 15.1736 6.62901 14.7831 6.23028L9.44991 0.822891C9.06395 0.428687 8.71098 0.170042 8.3617 0.109513V6.77134C8.3617 7.14104 8.54737 7.31849 8.90513 7.31849Z"
        fill={color}
      />
    </svg>
  );
};

export { FileSvg };
